export const API_BASE = "https://bw44-anywhere-fitness.herokuapp.com";

export default API_BASE;
